import React from "react";
import style from "./termsAndPolicy.module.css";
import BackButton from "Components/Back/BackButton";
import { useNavigate } from "react-router-dom";

export const Privacy = () => {
  const navigate = useNavigate();
  return (
    <div className={style.container}>
      <div onClick={() => navigate(-1)} className={style.back}>
        <BackButton />
      </div>

      <div class="ql-editor" className={style.privacy}>
        <p style={{ textAlign: "center" }}>
          <strong>PRIVACY POLICY</strong>
        </p>
        <br />
        <ol>
          <li>
            <strong>EFFECTIVE DATE</strong>
            <ol>
              <li>
                DNXG informs you of our policies regarding the collection, use,
                and revelation of personal data when you visit or use our
                Platform or Services and the possibilities which are associated
                with that information.&nbsp;
              </li>
              <li>
                We use your data to furnish and enhance the Platform and our
                Services.&nbsp;
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>WHAT IS PERSONAL DATA</strong>
            <ol>
              <li class="ql-indent-1">
                Personal Data means data/information about a living individual
                who can be identified from those data (or from those and other
                information either in our ownership or likely to come into our
                possession).&nbsp;
              </li>
              <li class="ql-indent-1">
                Aggregated data is considered non-personal data for the purposes
                of this Privacy Policy.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>PERSONAL DATA COLLECTS FROM YOU</strong>
            <ol>
              <li class="ql-indent-1">
                While using our Service or Products, we may ask you to provide
                us with certain personal information/data that can be used to
                contact or identify you (“Personal Data”).&nbsp;
              </li>
              <li class="ql-indent-1">
                Personal information/data may include, but is not limited to:
              </li>
              <ul>
                <li> Name</li>
                <li> Email Id</li>
                <li> Phone Number</li>
                <li> Company Name</li>
                <li> Designation</li>
                <li> Message</li>
              </ul>
              <li>
                We may use your Personal information to contact you with any
                newsletters, marketing or promotional materials and other
                information that may be of interest to you. You may opt out of
                receiving any, or all, of these communications from us by
                following the unsubscribe link or instructions provided in any
                email we send or by contacting us.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>LINKS TO OTHER SITES</strong>
            <ol>
              <li class="ql-indent-1">
                DNXG may contain links to other sites that are not operated by
                us. If you click on a third-party link, you will be directed to
                that third party’s web site. We strongly advise you to review
                the Privacy Policy of every site you visit.&nbsp;
              </li>
              <li class="ql-indent-1">
                We have no authority over and assume no responsibility for the
                content, privacy policies or practices of any third-party sites
                or services.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>USE OF PERSONAL DATA</strong>
            <ol>
              <li class="ql-indent-1">
                DNXG uses the collected data for various purposes:
              </li>
            </ol>
            <ul>
              <li>To provide and sustain our Service</li>
              <li>To inform you about changes to our Service</li>
              <li>
                To allow you to participate in interactive features of our
                Service when you choose to do so
              </li>
              <li>To provide customer support</li>
              <li>
                To gather research or valuable information so that we can
                improve our Service
              </li>
              <li>To monitor the usage of our Service</li>
              <li>To detect, prevent and address technical issues</li>
              <li>
                To provide you with news, special offers and general information
                about other goods, services and events which we offer that are
                similar to those that you have already secured or enquired about
                unless you have opted not to receive such information.
              </li>
            </ul>
          </li>
          <br />
          <li>
            <strong>SHARING OF PERSONAL DATA</strong>
            <ol>
              <li class="ql-indent-1">
                Business Transactions{" "}
                <p>
                  If DNXG is involved in a merger, acquisition or asset sale,
                  your Personal Data may be transferred.
                </p>
              </li>
              <li class="ql-indent-1">
                Disclosure for Law Enforcement
                <p>
                  Under certain circumstances, DNXG may be required to disclose
                  your Personal information if required to do so by law or in
                  response to valid requests by public authorities (e.g. a court
                  or a government agency).
                </p>
              </li>
              <li class="ql-indent-1">
                Legal Requirements
                <p>
                  DNXG may disclose your Personal Data in the good faith belief
                  that such action is necessary to:
                </p>
                <ul>
                  <li>To comply with a legal obligation;</li>
                  <li>
                    To protect and defend the rights or property of Dimension
                    NXG Private Limited;
                  </li>
                  <li>
                    To prevent or investigate possible wrongdoing in connection
                    with the Service;
                  </li>
                  <li>
                    To protect the personal safety of users of the Service or
                    the public;
                  </li>
                  <li>To protect against legal liability&nbsp;</li>
                </ul>
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>SECURITY OF PERSONAL DATA</strong>
            <ol>
              <li class="ql-indent-1">
                DNXG is committed to securing your personnel data and keeping it
                confidential. DNXG has done all in its power to prevent data
                theft, unauthorized access, and disclosure by implementing the
                latest technologies and software, which help us protect all the
                information we collect online. Additionally, we review our
                information collection, storage and processing practices,
                including physical security measures, to prevent unauthorised
                access to our systems.
              </li>
              <li class="ql-indent-1">
                We have adopted and implemented reasonable policies and
                standards related to security.
              </li>
              <li class="ql-indent-1">
                We conduct appropriate background checks of employees, vendors,
                and others with access to your personal information to enter
                into written confidentiality agreements.
              </li>
              <li class="ql-indent-1">
                We conduct regular trainings to make employees and others with
                access to your personal information aware of information
                security risks and to enhance compliance with DNXG’s policies
                and standards related to data protection.
              </li>
              <li class="ql-indent-1">
                We prevent unauthorized access to your personal information
                through the use, as appropriate, of physical and logical
                (passwords) entry controls, secure areas for data processing,
                procedures for monitoring the use of data processing facilities,
                built-in system audit trails, use of secure passwords, network
                intrusion detection technology, encryption and authentication
                technology, secure log-on procedures, and virus protection,
                monitoring compliance with DNXG’s policies and standards related
                to data protection on an ongoing basis
              </li>
              <li class="ql-indent-1">
                We restrict access to your personal information to our
                employees, contractors and agents who need that information in
                order to process it. Anyone with this access is subject to
                strict contractual confidentiality obligations and may be
                disciplined or terminated if they fail to meet these
                obligations. In particular, we provide:
                <ul>
                  <li>
                    Physical access control measures to prevent unauthorized
                    access to data processing systems
                  </li>
                  <li>
                    Denial-of-use control measures to prevent unauthorized use
                    of data protection systems
                  </li>
                  <li>
                    Requirements-driven authorization scheme and access rights,
                    and monitoring and logging of system access to ensure that
                    persons entitled to use a data processing system have access
                    only to the data to which they have a right of access, and
                    that your personal information cannot be read, copied,
                    modified, or removed without authorization
                  </li>
                  <li>
                    Data transmission control measures to ensure that your
                    personal information cannot be read, copied, modified, or
                    removed without authorization during electronic
                    transmission, transport, or storage on data media, and
                    transfer and receipt of record
                  </li>
                  <li>
                    Taking such other steps as may be appropriate under the
                    circumstances
                  </li>
                </ul>
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>YOUR RIGHTS</strong>
            <ol>
              <li class="ql-indent-1">
                DNXG aims to take reasonable steps to allow you to correct,
                amend, delete, or limit the use of your Personal information.
              </li>
              <li class="ql-indent-1">
                Whenever made possible, you can update your Personal Data
                directly within your account settings section. If you are unable
                to change your Personal Data, please contact us to make the
                required changes.
              </li>
              <li class="ql-indent-1">
                If you wish to be informed what Personal Data we hold about you
                and if you want it to be removed from our systems, please
                contact us.
              </li>
              <li class="ql-indent-1">
                In certain circumstances, you have the right:
                <ul>
                  <li>
                    To access and receive a copy of the Personal Data we hold
                    about you
                  </li>
                  <li>
                    To rectify any Personal Data held about you that is
                    inaccurate
                  </li>
                  <li>
                    To request the deletion of Personal Data held about you
                  </li>
                  <li>
                    You have the right to data portability for the information
                    you provide to DNXG
                  </li>
                  <li>
                    You can request to obtain a copy of your Personal Data in a
                    commonly used electronic format so that you can manage and
                    move it. Please note that we may ask you to verify your
                    identity before responding to such requests.
                  </li>
                </ul>
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>THIRD PARTY DATA SHARING</strong>
            <ol>
              <li class="ql-indent-1">
                We may employ third party companies and individuals to
                facilitate our Service (“Service Providers”), to provide the
                Service on our behalf, to perform Service-related services or to
                assist us in analysing how our Service and Platform is used.
                Also, a third party data sharing party may be a business entity
                that does not have direct relationship with you but is in
                contractual relationship with us or making use of any of our
                platforms or services that involves exchange or sharing of your
                personal information.&nbsp;
              </li>
              <li class="ql-indent-1">
                These third parties have access to your Personal Data only to
                perform these tasks on our behalf and are obligated not to
                disclose or use it for any other purpose. DNXG privacy policies
                are made applicable to third party whenever they have access to
                any personal information in connection with this Agreement. The
                Third Party shall:
                <ul>
                  <li>
                    Comply with all laws relating to data privacy, protection of
                    personal information, and the cross-border transfer of
                    personal information
                  </li>
                  <li>
                    Only collect, access, use, or share personal information, or
                    transfer personal information to authorized third parties,
                    in performance of its obligations under this Agreement, in
                    conformance with DNXG’s instructions, or to comply with
                    legal obligations
                  </li>
                  <li>
                    Not make any secondary or other use (e.g., for the purpose
                    of direct marketing or data mining) of personal information
                    except (i) as expressly authorized in writing by DNXG, or
                    (ii) as required by law
                  </li>
                  <li>
                    Not share, transfer, disclose or provide access to personal
                    information to any third party except to provide services
                    under this Agreement or as required by law;
                  </li>
                  <li>
                    Take commercially reasonable steps to ensure the reliability
                    of third party personnel who have access to the personal
                    information and ensure that such access is on a need-to-know
                    basis;
                  </li>
                  <li>
                    Provide DNXG with commercially reasonably assistance in (i)
                    deleting personal information upon request by you or your
                    legal representative; (ii) providing appropriate privacy
                    notices to you; and (iii) enable you to opt-out of the
                    collection and/or use of your personal information
                  </li>
                  <li>
                    Provide written notice to DNXG as soon as possible and, in
                    no instance in more than 48 hours of any actual or
                    reasonably suspected incident of accidental or unlawful
                    destruction or accidental loss, alteration, unauthorized or
                    accidental disclosure of or access to personal information
                    of which it becomes aware (a "Security Breach"); thereafter
                    shall take all reasonable measures to contain and remedy the
                    Security Breach, wherever possible; provide DNXG with
                    information regarding the investigation and remediation of
                    the Security Breach; not make any notification, announcement
                    or publish or otherwise authorize any broadcast of any
                    notice or information about a Security Breach without the
                    prior written consent of and prior written approval by DNXG
                    of the content, media and timing of the Security Breach
                    Notice (if any), unless required to do so by law or court
                    order; and even where required to do so by law or court
                    order, make all reasonable efforts to coordinate with DNXG
                    prior to providing any Security Breach Notice.
                  </li>
                </ul>
                <li>
                  If the third party does share, transfer, disclose or provide
                  access to personal information to any other third party, it
                  shall:
                  <ul>
                    <li>
                      Be responsible for the acts and omissions of such other
                      third party, that processes personal information, in the
                      same manner and to the same extent as it is responsible
                      for its own acts and omissions with respect to such
                      personal information;
                    </li>
                    <li>
                      Ensure such third party is bound by a written agreement
                      that contains the same or equivalent obligations and
                      protections as those set forth in this Agreement; and
                    </li>
                    <li>
                      Only share, transfer, disclose or provide access to a
                      third party to the extent that such conduct is compliant
                      with applicable law.
                    </li>
                  </ul>
                </li>
                <li>
                  Where the Security Breach involves data elements that could
                  lead to identity theft and is on the third party’s networks or
                  systems or is the fault of third party, the third party
                  acknowledges and agrees that it will remain liable to you for
                  such security breach or other terms of this Agreement and
                  will, pay for the costs of remediation, notification
                  (including, where reasonably necessary), and provide you with
                  adequate compensation as directed by law or a government
                  regulator.
                </li>
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>CHILDREN’S PRIVACY POLICY</strong>
            <ol>
              <li class="ql-indent-1">
                Our Platform does not address anyone under the age of 13
                (“Children”). We do not knowingly collect personally
                identifiable information from anyone under the age of 13. If you
                are a parent or guardian and you are aware that your children
                has provided us with Personal Data, please contact us.&nbsp;
              </li>
              <li class="ql-indent-1">
                If we become aware that we have collected Personal Data from
                children without verification of parental consent, we take steps
                to remove that information from our servers.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>TRACKING COOKIES DATA</strong>
            <ol>
              <li class="ql-indent-1">
                We use cookies and similar tracking technologies to track the
                activity on our Platform and hold certain information. Cookies
                are files with small amount of data which may include an
                anonymous unique identifier. Cookies are sent to your browser
                from a website and stored on your device. Tracking technologies
                also used are beacons, tags, and scripts to collect and track
                information and to improve and analyze our Platform.
              </li>
              <li class="ql-indent-1">
                You can instruct your browser to refuse all cookies or to
                indicate when a cookie is being sent. However, if you do not
                accept cookies, you may not be able to use some portions of our
                Platform. Examples of Cookies we use:
              </li>
              <li class="ql-indent-1">
                Session Cookies. We use Session Cookies to operate our Platform.
              </li>
              <li class="ql-indent-1">
                Preference Cookies. We use Preference Cookies to remember your
                preferences and various settings.
              </li>
              <li class="ql-indent-1">
                Security Cookies. We use Security Cookies for security purposes.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>CHANGES TO THIS PRIVACY POLICY</strong>
            <ol>
              <li class="ql-indent-1">
                We may update our Privacy Policy from time to time. We will
                inform you of any modification by posting the new Privacy Policy
                on this page. We will update you via email and/or a prominent
                notice on our Service, prior to the change becoming effective
                and update the “effective date” at the top of this Privacy
                Policy.
              </li>
              <li class="ql-indent-1">
                You are advised to review this Privacy Policy periodically for
                any changes. Changes to this Privacy Policy are effective when
                they are posted on this page.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>JURISDICTION</strong>
            <ol>
              <li class="ql-indent-1">
                If you choose to visit the website, your visit and any dispute
                over privacy is subject to this Policy and the Platform’s terms
                of use. In addition to the foregoing, any disputes arising under
                this Policy shall be governed by the laws of India.
              </li>
            </ol>
          </li>
        </ol>

        <p>
          <br />
        </p>
      </div>
    </div>
  );
};
